import { ReactNode } from "react";
import CommonPopup from "./CommonPopup";
import style from "./PopupMessage.module.css";

function PopupMessage(props: {
    type: "success" | "warning" | "error"; // 消息类型：success, warning, error
    message: string;
    active: boolean;
    zIndex?: number;
    children?: ReactNode;
}) {
    return (
        <CommonPopup active={props.active} zIndex={props.zIndex || 9999}>
            <div className={style['msg-' + props.type]}>{props.message}</div>
        </CommonPopup>
    );
}
export default PopupMessage;